'use strict';

$(document).ready(function () {
    const iframeOrigin = $('.appointment-iframe').length ? new URL($('.appointment-iframe').attr('src')).origin : null;

    $('body').on('click', '.appointment-btn', function (event) {
        event.preventDefault();

        const $this = $(this);

        if ($this.hasClass('appointmentButton')) return;

        const linkType = $this.data('linkType');
        const url = $this.data('url');
        const modal = $this.closest('.appointment-btn-container').find('.appointment-btn-modal');
        const appointmentBtnsWrapper = $this.closest('.appointment-btns-wrapper ');

        if (linkType === 'iframe') {
            const body = $('body');
            const iframeCloseMessage = $this.data('iframeCloseMessage');
            const closeIframe = function (e) {
                const iframeEvent = e.originalEvent;

                if (iframeEvent.origin === iframeOrigin && iframeEvent.data === iframeCloseMessage && iframeEvent.source === modal.find('iframe')[0].contentWindow) {
                    modal.find('iframe').remove();
                    appointmentBtnsWrapper.removeClass('active');
                    modal.css('display', 'none');
                    body.css('overflow', '');
                    modal.append(
                        $('<iframe>', {
                            src: url,
                            width: '100%',
                            height: '100%',
                            css: {
                                overflow: 'hidden',
                                border: 'none'
                            }
                        })
                    );

                    $(window).off('message', closeIframe);
                }
            };

            appointmentBtnsWrapper.addClass('active');
            modal.css('display', 'block');
            body.css('overflow', 'hidden');

            $(window).on('message', closeIframe);
        } else if (linkType === 'external') {
            window.open(url, '_blank');
        } else {
            $.ajax({
                url: url,
                type: 'GET'
            });

            appointmentBtnsWrapper.addClass('active');
            modal.modal('toggle');
            $('.modal-backdrop').appendTo($(this).closest('.appointment-btn-container'));
            modal.on('hidden.bs.modal', () => {
                appointmentBtnsWrapper.removeClass('active');
            });

            if ($this.hasClass('js-order-by-email')) {
                $('#appointment-form').append('<input type="hidden" name="productId" value="' + $this.data('product-id') + '">');
                $('#appointment-form').append('<input type="hidden" name="appointmentFormTopic" value="' + $this.data('case-topic') + '">');
            }
        }
    });

    document.documentElement.style.setProperty('--appointment-btns-bottom', $('.appointment-btns-wrapper').attr('bottom'));

    const $wrapper = $('.appointment-btns-wrapper');
    const footerEl = $('.footerMenu').closest('footer')[0] || $('.footerMenu')[0];

    if ($wrapper.length && footerEl) {
        $(window).on('scroll resize', function () {
            $wrapper.toggleClass('is-footer-overlap', $wrapper[0].getBoundingClientRect().bottom > footerEl.getBoundingClientRect().top);
        }).trigger('scroll');
    }
});
